import React, { useState, useContext, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import LockIcon from "@mui/icons-material/Lock";

import styles from "./styles.module.css";

import logoBrancoAltura from "../../images/logoBrancoAltura.png";

import {
  alterarSenhaHandler,
} from "../../services/auth.service";

import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import { Link } from "@mui/material";

export const RedefinirSenha = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [senha, setSenha] = useState({});
  const [token, setToken] = useState({});
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [status, setStatus] = useState({
    type: "",
    mensagem: "",
    loading: false,
  });
  const [msg, setMsg] = useState("");

  useEffect(() => {
    // Obtendo a query string da URL
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // Obtendo o valor do parâmetro 'token' da query string
    setToken(urlParams.get("token"));
  }, []);

  const handleAlterarSenha = async () => {
    if (senha.senha1 !== senha.senha2) {
      setMsg("O campo de confirmação não é igual ao campo da senha.");
      handleOpenSnackbarErro();
      return;
    }

    setStatus({
      loading: true,
    });

    await alterarSenhaHandler(token, {nova_senha: senha.senha1})
      .then((response) => {
        setMsg(response.mensagem);
        handleOpenSnackbarSucesso();
        navigate('/');
        setStatus({
          loading: false,
        });
      })
      .catch((err) => {
        handleErrorResponse(err);
      });

  };

  const { from = "/login" } = state || {};

  const handleErrorResponse = (err) => {
    setStatus({
      loading: false,
    });
    if (err.response) {
      setMsg(err.response.data.mensagem);
      handleOpenSnackbarErro();
    } else {
      setMsg("Erro: Tente novamente!");
      handleOpenSnackbarErro();
    }
  };

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const navigateToLogin = () => {
    navigate('/login')
  }

  return (
    <div className={styles.backgroundPublic}>
      <Card className={styles.cardLogin}>
        <CardContent>
          <div className={styles.divHeaderLogin}>
            <Link
              component="button"
              onClick={navigateToLogin}
              sx={{
                marginTop: "1"
              }}>
              <img
                className={styles.imgAltura}
                src={logoBrancoAltura}
                alt="Logo"
              />
            </Link>
          </div>
          <TextField
            className={styles.senhaTextField}
            fullWidth
            size="small"
            variant="outlined"
            type="password"
            name="senha"
            placeholder="Digite a nova senha"
            onChange={(e) => setSenha({ ...senha, senha1: e.target.value })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <div className={styles.fundoUsuario}>
                    <LockIcon className={styles.iconeUsuario} />
                  </div>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            className={styles.senhaTextField}
            fullWidth
            size="small"
            variant="outlined"
            type="password"
            name="novamentesenha"
            placeholder="Confirme a nova senha"
            onChange={(e) => setSenha({ ...senha, senha2: e.target.value })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <div className={styles.fundoUsuario}>
                    <LockIcon className={styles.iconeUsuario} fontSize="30px"/>
                  </div>
                </InputAdornment>
              ),
            }}
          />
          <Button
            // type="submit"
            className={styles.botaoAcessar}
            variant="contained"
            onClick={handleAlterarSenha}
          >
            Alterar
          </Button>

          {status.type === "error" ? (
            <p className={styles.mensagemUsuario}>{status.mensagem}</p>
          ) : (
            ""
          )}
          {status.type === "success" ? (
            <p className={styles.mensagemUsuario}>{status.mensagem}</p>
          ) : (
            ""
          )}
          {status.loading ? (
            <p className={styles.mensagemUsuario}>Carregando...</p>
          ) : (
            ""
          )}
        </CardContent>
        <CardActions></CardActions>
      </Card>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};
